import { render, staticRenderFns } from "./Request_Del.vue?vue&type=template&id=30161f00&"
import script from "./Request_Del.vue?vue&type=script&lang=js&"
export * from "./Request_Del.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports